import { render, staticRenderFns } from "./idleAlert.vue?vue&type=template&id=28ed796e&scoped=true"
import script from "./idleAlert.vue?vue&type=script&lang=ts"
export * from "./idleAlert.vue?vue&type=script&lang=ts"
import style0 from "./idleAlert.vue?vue&type=style&index=0&id=28ed796e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ed796e",
  null
  
)

export default component.exports